<template>
  <v-container style="width: 100vw !important">
    <custom-heading :breadcrumbs="breadcrumbs" />

    <v-container class="mb-8">
      <v-tabs
        v-model="selected"
        centered
        style="border-bottom: thin solid rgba(0, 0, 0, 0.12);"
      >
        <v-tab
          v-for="(link, index) in navLinks"
          :key="link + '_' + index"
          @click="selected = index"
          style="min-width: 192px;"
          >{{ link }}</v-tab
        >
      </v-tabs>
    </v-container>

    <div>
      <student-info v-if="selected === 0"></student-info>
      <reset-password></reset-password>
    </div>
  </v-container>
</template>

<script>
import CustomHeading from "../heading/CustomHeading";
import StudentInfo from "./studentInfo/StudentInfo";
import ResetPassword from "../dialogs/ResetPassword";

export default {
  components: {
    CustomHeading,
    StudentInfo,
    ResetPassword,
  },
  created() {
    var studentId = this.$route.params.ucenik_id;
    this.selected = this.$route.query ? +this.$route.query.tab : 0;

    this.$axios.post("ucenik/" + `${studentId}`).then((response) => {
      this.breadcrumbs.push({
        text: response.data.first_name + " " + response.data.last_name,
      });
    });
  },
  data() {
    return {
      breadcrumbs: [
        { text: "Administracija" },
        { text: "E-matica" },
        { text: "Učenici", href: "/admin/ucenik" },
      ],
      selected: 0,
      navLinks: ["osnovni podaci"],
    };
  },
};
</script>

<style>
.student-navigation p {
  cursor: pointer;
  position: relative;
  font-size: 14px;
  padding: 20px 16px;
  text-transform: uppercase;
}

.add_animation,
.default_link {
  display: inline-block;
  border-bottom: 3px solid #004379;
  padding-bottom: 2px;
}
</style>
